import { Outlet } from 'react-router-dom'
// import Footer from './Footer'
import HaNavbar from './HaNavbar'
import { ProgressBar } from 'react-bootstrap'
import { useContext } from 'react'
import { AuthContext } from './AuthContext'
const Layout = ({
  currentUser,
  setCurrentUser,
  loginShow,
  setLoginShow,
  redirectTo,
  setRedirectTo,
  sendDiscordNotification,
}) => {
  const { isLoading } = useContext(AuthContext)
  return (
    <div className="d-flex layout">
      <HaNavbar
        currentUser={currentUser}
        setCurrentUser={setCurrentUser}
        loginShow={loginShow}
        setLoginShow={setLoginShow}
        redirectTo={redirectTo}
        setRedirectTo={setRedirectTo}
        sendDiscordNotification={sendDiscordNotification}
      />
      {isLoading ? (
        <div className="m-5 w-100 text-center">
          <ProgressBar className="m-4" animated now={100} />
          <h5 className="text-secondary">資料等待中...</h5>
        </div>
      ) : (
        <Outlet />
      )}

      {/* <Footer /> */}
    </div>
  )
}

export default Layout
